import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

export const fetchDashboard = (dateRange = {}) => {
  const authToken = localStorage.getItem("authToken");

  return axiosInstance.get(`${ADMIN_API_URL}/dashboard`, {
    headers: {
      ...getDefaultHeaders(),
      Authorization: `Bearer ${authToken}`,
    },
    params: dateRange,
  });
};
